import { ErrorCode } from '../generated/errorCodes.gen';

/**
 * True when `err` carries exactly one of `codes` in its `code` field. Errors keep `code` as a plain string, because
 * proxies and 500s send codes the API never declared; this is where a check names a code, so it must be a generated one.
 */
export function hasErrorCode(err: unknown, ...codes: readonly ErrorCode[]): boolean {
  if (typeof err !== 'object' || err === null || !('code' in err)) return false;
  return (codes as readonly unknown[]).includes(err.code);
}

const STALE_SUFFIXES: readonly string[] = [ErrorCode.StaleWrite, ErrorCode.ConcurrencyConflict, ErrorCode.ConcurrencyMismatch];

const STALE_WRITE_CODES: readonly string[] = Object.values(ErrorCode).filter((code) =>
  STALE_SUFFIXES.some((suffix) => code.endsWith(suffix)),
);

/**
 * True when another write changed the row first: the `StaleWrite` code, or any per-endpoint code the API
 * sent before it (`<Action>ConcurrencyConflict`, the report endpoints' `<Action>ConcurrencyMismatch`).
 */
export function isStaleWrite(err: unknown): boolean {
  if (typeof err !== 'object' || err === null || !('code' in err)) return false;
  return STALE_WRITE_CODES.includes(err.code as string);
}
